module.exports = __webpack_public_path__ + "static/img/DSC_0092_02.c104b03e.png";